export default class extends ApplicationController {
  remove() {
    this.element.remove()
  }
}
